export const copyTextToClipboard = (text: string) => {
  // Workaround for Safari browser
  return setTimeout(async () => {
    await navigator.clipboard.writeText(text);
  });
};
